export function avatarInitial(name: string): string {
  return (name.replace(/[^a-zA-Z]/g, '')[0] || 'P').toUpperCase();
}

export function avatarColor(name: string): string {
  const palettes = [
    'linear-gradient(145deg, #6B5B95 0%, #3D2A6B 100%)',
    'linear-gradient(145deg, #2E7D6E 0%, #0D3D36 100%)',
    'linear-gradient(145deg, #8B4513 0%, #4A2408 100%)',
    'linear-gradient(145deg, #455A64 0%, #263238 100%)',
    'linear-gradient(145deg, #9B2335 0%, #5A1420 100%)',
  ];
  const n = name.split('').reduce((a, c) => a + c.charCodeAt(0), 0);
  return palettes[n % palettes.length];
}
